module.exports = __webpack_public_path__ + "media/images/iconSocialMail__errorRed--dark-0833f58c4c8ba264af2ebe3858d525d8.png";